// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__yg361","rowWrap":"styles_rowWrap__HfY4H","backButton":"styles_backButton__uLcSB","changesList":"styles_changesList__FxNC1"};